import { Modal, Space, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { StateTypes } from "../model/data";
import { setIsTermAndConditionVisible } from "../model/dashboard";

const TermsAndConditions = () => {
  const { isTermAndConditionVisible } = useSelector((state: StateTypes) => state.dashboard)

  const dispatch = useDispatch()

  return (
    <Modal
      open={isTermAndConditionVisible}
      title="Terms and conditions"
      centered
      onCancel={() => dispatch(setIsTermAndConditionVisible(false))}
      width={433}
      footer={
        <Space
          direction="horizontal"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
        </Space>
      }
      bodyStyle={{ height: 400, overflowY: "scroll" }}
      closable={true}
      maskClosable={false}
    >
      <Typography.Paragraph>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</Typography.Paragraph>
      <Typography.Paragraph>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</Typography.Paragraph>
      <Typography.Paragraph>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</Typography.Paragraph>
    </Modal>
  );
};

export default TermsAndConditions;
